let code = 'gimgestao';
let codeAPI = 'gim';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};